import { ReactComponent as Scope } from './scope.svg'

export default Scope
